"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const Button_1 = __importDefault(require("../../../components/Button"));
const IconType_1 = __importDefault(require("../../../components/enums/IconType"));
const IdHeader_1 = __importDefault(require("../../../components/IdHeader"));
const IllustrationNoDrawing_1 = __importDefault(require("../../../components/illustrations/IllustrationNoDrawing"));
//import NewEmailSet from "../../../components/popups/ResetEmailDone";
const TextInput_1 = __importDefault(require("../../../components/TextInput"));
const ResetEmail = () => {
    const [isResetEmailFormFilled, setIsResetEmailFormFilled] = (0, react_1.useState)(false);
    //New Email Form Variables
    const [hash, setHash] = (0, react_1.useState)("");
    const [email, setEmail] = (0, react_1.useState)("");
    const [userId, setUserId] = (0, react_1.useState)("");
    const [newEmail, setNewEmail] = (0, react_1.useState)("");
    const [newEmailAgain, setNewEmailAgain] = (0, react_1.useState)("");
    const [isNewEmailError, setIsNewEmailError] = (0, react_1.useState)(false);
    const [newEmailErrorMessage, setNewEmailErrorMessage] = (0, react_1.useState)("");
    const differenceError = "A beírt email címek nem egyeznek!";
    const lengthError = "Nem írtál be új emailt!";
    const serverErrorMessage = "A bejelentkezés során váratlan szerver hiba lépett fel!";
    react_1.default.useEffect(() => {
        if (document.getElementById("react-data")) {
            try {
                let data = document
                    .getElementById("react-data")
                    .getAttribute("encoded");
                let parsed_data = JSON.parse(data);
                if (parsed_data.hash) {
                    setHash(parsed_data.hash);
                }
                if (parsed_data.e) {
                    setEmail(parsed_data.e);
                }
                if (parsed_data.user_id) {
                    setUserId(parsed_data.user_id);
                }
            }
            catch (error) { }
        }
    });
    //Create Email Handler Functions
    const newEmailCreationDone = (e) => {
        e.preventDefault();
        if (newEmail.length === 0) {
            setIsNewEmailError(true);
            setNewEmailErrorMessage(lengthError);
            return false;
        }
        if (newEmail !== newEmailAgain) {
            setIsNewEmailError(true);
            setNewEmailErrorMessage(differenceError);
            return false;
        }
        fetch("/email-reset", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                user_id: userId,
                e: email,
                email: newEmail,
                email_confirm: newEmailAgain,
                hash: hash,
            }),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (!content.success) {
                    return false;
                }
                if (content.response.action) {
                    window.location.href = content.response.action;
                }
            })
                .catch(() => { });
        })
            .catch(() => { });
        return;
    };
    (0, react_1.useEffect)(() => {
        if (newEmail.length !== 0 && newEmailAgain.length !== 0) {
            setIsResetEmailFormFilled(true);
        }
        else {
            setIsResetEmailFormFilled(false);
        }
        if (newEmailErrorMessage === lengthError) {
            setIsNewEmailError(false);
        }
        else if (newEmailErrorMessage === differenceError &&
            newEmail === newEmailAgain) {
            setIsNewEmailError(false);
        }
    }, [newEmail, newEmailAgain]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(IdHeader_1.default, { handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("main", { className: "reset-password" },
            react_1.default.createElement("section", { className: "reset-password__content" },
                react_1.default.createElement("div", { className: "reset-password__form-container" },
                    react_1.default.createElement("h1", { className: "reset-password__title" }, "\u00DAj e-mail c\u00EDm be\u00E1ll\u00EDt\u00E1sa"),
                    react_1.default.createElement("form", { className: "reset-password__form", onSubmit: newEmailCreationDone, method: "post" },
                        react_1.default.createElement(TextInput_1.default, { label: "\u00DAj e-mail c\u00EDm", name: "\u00FAj e-mail", value: newEmail, onChangeHandler: setNewEmail, placeholder: "\u00CDrd be az \u00FAj e-mail c\u00EDmedet", isRequired: true, type: "email", state: isNewEmailError ? "error" : "normal", errorText: newEmailErrorMessage, unit: "" }),
                        react_1.default.createElement(TextInput_1.default, { label: "\u00DAj e-mail c\u00EDm meger\u0151s\u00EDt\u00E9se", name: "\u00FAj e-mail c\u00EDm meger\u0151s\u00EDt\u00E9se", value: newEmailAgain, onChangeHandler: setNewEmailAgain, placeholder: "\u00CDrd be m\u00E9g egyszer az \u00FAj e-mail c\u00EDmedet", isRequired: true, type: "email", state: isNewEmailError ? "error" : "normal", errorText: newEmailErrorMessage, unit: "" }),
                        react_1.default.createElement(Button_1.default, { label: "Ment\u00E9s", type: "primary", icon: IconType_1.default.None, state: isResetEmailFormFilled
                                ? "enabled"
                                : "disabled", handlerFunction: () => { }, action: "submit" })))),
            react_1.default.createElement("div", { className: "reset-password__illustration" },
                react_1.default.createElement("h1", { className: "reset-password__title-mobile" }, "\u00DAj e-mail c\u00EDm be\u00E1ll\u00EDt\u00E1sa"),
                react_1.default.createElement(IllustrationNoDrawing_1.default, null,
                    react_1.default.createElement(react_1.default.Fragment, null))))));
};
exports.default = ResetEmail;
if (document.getElementById("Core-ResetEmail-index")) {
    (0, client_1.createRoot)(document.getElementById("Core-ResetEmail-index")).render(react_1.default.createElement(ResetEmail, null));
}
